import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useContext,useEffect,useState } from 'react';
import { ContextFromSelections } from './Context';
import ImageIcon from '@mui/icons-material/Image';
import { Typography } from '@mui/material';



export default function TextOnRibbon() {

  
  
  const [selectedData, setSelectedData] = useContext(ContextFromSelections);
  const [RibbonText,setRibbonText] = useState(selectedData.textOnRibbon)
  
  const HandleTextChange = (event) => {

    setRibbonText(event.target.value);
  }
   
  
  
  
  useEffect(() => {
    setSelectedData((data) => ({...data,textOnRibbon: RibbonText}))
  },[RibbonText])
  

  return (

        <Box sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: "3px",
          p: 0.1,
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}>
            <Box
              display="flex"
              width={{xs: "100%", md: "100%"}}
              height="70px"
              sx={{
                margin: 'auto',
                justifyContent: 'center',
                alignItems: "center",
                borderRadius: "2px",
                borderBottom: `3px solid ${selectedData.ribbonColorCode}`,
                borderTop: `3px solid ${selectedData.ribbonColorCode}`,
               
              }}
            >
              
              <Box
                  
                  sx={{

                    display: "flex",
                    height: "100%",
                    width: "100%",
                    justifyContent: 'center',
                    alignItems: "center",
                    margin: "auto",
                    borderBottom: selectedData.ribbonBorderAdd  && selectedData.fontColorCode ? `5px solid ${selectedData.fontColorCode}` : `5px solid ${selectedData.ribbonColorCode}`,
                    borderTop:  selectedData.ribbonBorderAdd  && selectedData.fontColorCode ? `5px solid ${selectedData.fontColorCode}` : `5px solid ${selectedData.ribbonColorCode}`,
                    bgcolor: selectedData.ribbonColorCode,
                    p:1

                   
                    
                }}
                >
                  { selectedData.uploaded_file && 
                  <Box sx={{
                    flex : selectedData.addText || selectedData.icon ? 0.2 : 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    

                    
                  }}>
                    <Box sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      width: 80,
                      height: 50,
                      justifyContent: 'center',
                      alignItems: "center",
                      borderRadius: "7px",
                      border: selectedData.fontColorCode ? `1px dashed ${selectedData.fontColorCode}` : '1px dashed black',
                      p: 0.5
                      
                    
                      
                    }}>
                      <ImageIcon sx={{ color: selectedData.fontColorCode,fontSize: 25}}/>
                      <Typography  sx={{color: selectedData.fontColorCode,fontSize: 8}}>Uploaded Logo</Typography>
                    
                    </Box>
                  
                  </Box> }
                  { selectedData.addText && <Box 
                    sx={{
                    flex: selectedData.addText ? 1 : null,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    }}>
                  <TextField
                    disabled={!selectedData.addText}
                    value={selectedData.addText === false ? "" : undefined}
                    variant="standard"
                    fullWidth
                    defaultValue={selectedData.textOnRibbon}
                    placeholder={selectedData.addText ? "Type here..." : ""}
                    onChange={HandleTextChange}
                    inputProps={{
                      maxLength: 50
                    }}
                    

                    sx={{
                      "& .MuiInput-underline:before, & .MuiInput-underline:after": {
                        display: "none", 
                      },
                      "& .MuiInputBase-root": {
                        borderBottom: "none !important", 
                      },
                      "& .MuiInputBase-input": {
                        color: selectedData.fontColorCode,
                        fontFamily: selectedData.font,
                        fontSize: {md: 28, xs: 24},
                        fontWeight: "bold",
                        bgcolor: selectedData.ribbonColorCode,
                        textAlign: "center",
                        
                      },
                    }}
                  />
                  </Box> }
                  
                  { selectedData.icon && <Box sx={{
                    flex: selectedData.addText || selectedData.uploaded_file ? 0.15 : 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",   

                  }}>

                  </Box>}
                  
                  </Box>
                </Box>
              </Box>
                  
            );
}



